'use strict';

function UsersNavigationController($route) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.isCurrent = isCurrent;

  function $onInit() {
    vm.urls = {
      list: '/admin/users/',
      create: '/admin/users/create',
      'import': '/admin/users/import',
      'change_manager': '/admin/users/change-manager',
      'importContacts': '/admin/users/contacts',
      'statistics':'companyadmin/statistics/assessments/'
    };
  }

  function isCurrent(route) {
    return $route.current.regexp && $route.current.regexp.test((route || ' ').charAt(0) === '#' ? route.substring(1) : route);
  }
}

module.exports = UsersNavigationController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/users/users-navigation/users-navigation.controller.js
 ** module id = 164
 ** module chunks = 0
 **/